import OfflinePageWrapper from '../src/components/offline-page/offline-page-wrapper-component';

function App() {
  return (
    <OfflinePageWrapper />
  );
}

export default App;
